<template>
  <div id="app">
    <custom-header v-if="isHeader"></custom-header>
    <router-view/>
    <alert-popup :model="alertMessage" v-if="showAlert"></alert-popup>
  </div>
</template>

<script>
  import { globals } from '@/mixins/globals'
  import Header from '@/components/header'
  import AlertPopup from '@/components/alert'
  export default {
    name: 'App',
    mixins: [globals],
    components: {
      "custom-header": Header,
      "alert-popup": AlertPopup,
    },
    created() {
      var self = this;
      document.addEventListener("visibilitychange", self.closeAlert, false);
      window.addEventListener("locationchange", self.closeAlert, false);
    }
  }
</script>

<style>
#app {
  font-family: 'Avenir', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 65px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue